// extracted by mini-css-extract-plugin
export default {"base":"vertical-spacer_base__FIXnt"};